import { useMemo } from 'react';

import { useGetSubventionsQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { getSubventionsColumns, NO_ORGANIZATION_LABEL, type SubventionRow } from '../constants/subventionsColumns';

export const SubventionsList = () => {
    const { loading: subventionsLoading, data: subventionsData, error: subventionsError } = useGetSubventionsQuery();

    const columns = useMemo(() => {
        const subventions = subventionsData?.subventions ?? [];
        const organizationOptions = Array.from(
            new Map(
                subventions.map((subvention) => {
                    const name = subvention.organization?.name || NO_ORGANIZATION_LABEL;
                    return [name, { value: name, label: name }];
                }),
            ).values(),
        ).sort((a, b) => a.label.localeCompare(b.label));

        return getSubventionsColumns(organizationOptions);
    }, [subventionsData]);

    if (subventionsLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!subventionsData || subventionsError) {
        throw new Error('Une erreur est survenue lors de la récupération des subventions');
    }

    const { subventions } = subventionsData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<SubventionRow>
                columns={columns}
                data={subventions}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/subvention/${row._id}`}
                searchPlaceholder="Nom de la subvention"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
